import * as Sentry from '@sentry/browser';
import { useAppConfig } from '@/appConfig/useAppConfig.ts';
import { useState } from 'react';
import { empty, isNil } from 'ramda';
import { useConfirmRequest } from '@/saveRegistration/actions/useConfirmRequest.ts';
import { useForm } from '@/form/useForm.ts';

interface UseConfirmTransmissionApi {
  confirmTransmitStatus: ConfirmTransmissionStatus;
  confirmTransmission: () => Promise<void>;
}

export type ConfirmTransmissionStatus = 'unknown' | 'confirming' | 'confirmation-success' | 'confirmation-failure';

export const useConfirmTransmission = ({ spinnerDuration = 1000 }): UseConfirmTransmissionApi => {
  const meta = useAppConfig();
  const { getFormPayload } = useForm();
  const [confirmTransmitStatus, setConfirmTransmitStatus] = useState<ConfirmTransmissionStatus>('unknown');
  const { confirm } = useConfirmRequest();

  const confirmTransmission = () => {
    const gridId = getFormPayload().donorId;
    setConfirmTransmitStatus('confirming');

    if (!meta || empty(gridId) || isNil(gridId)) {
      setConfirmTransmitStatus('confirmation-failure');
      console.error('Metadata check or data error -- donorId:', gridId, ' meta: ', meta);
      Sentry.captureException({
        message: "Netadata check error: No 'registrationConfirmation' url found or grid id empty. ",
      });
      return Promise.reject();
    }

    return confirm(gridId)
      .then((res) => {
        // if(isLocalDev()) { // Locally
        //   // mark as transmitted
        //   setTimeout(() => {
        //     setConfirmTransmitStatus('confirmation-success');
        //   }, spinnerDuration);
        //   return;
        // }

        if (res.data.registration) {
          // All is well, confirmation given.
          // mark as transmitted
          setTimeout(() => {
            setConfirmTransmitStatus('confirmation-success');
          }, spinnerDuration);
        }

        if (!res.data.registration) {
          // All is well, confirmation given.
          // mark as transmitted
          setTimeout(() => {
            setConfirmTransmitStatus('confirmation-failure');
          }, spinnerDuration);
        }
      })
      .catch((e) => {
        setTimeout(() => {
          setConfirmTransmitStatus('confirmation-failure');
        }, spinnerDuration);
        console.error('Transmitting registration to backend: Confirmation failed.');
        Sentry.captureException(e);
      });
  };

  return { confirmTransmitStatus, confirmTransmission };
};
